import React, { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { colors } from 'constants-colors';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import { WhiteLabelType } from 'lane-shared/types/WhiteLabelType';

import { HookFormCheckBox } from '../../../../components/HookFormCheckBox';
import { SwireCommonTnC } from '../SwireCommonTnC';

import { useSwireApp } from 'react-hooks';

const labelStyles = {
  fontSize: '14px',
  fontWeight: 400,
  marginLeft: '10px',
};

type ReducedWhiteLabel = Pick<
  WhiteLabelType,
  'termsAndConditionsUrls' | 'privacyPolicyUrls' | 'name' | 'url'
>;

type Props = {
  control: Control<any>;
  whitelabel: ReducedWhiteLabel;
};


export function SwireHongKongTnC({ control, whitelabel }: Props) {
  const { t } = useTranslation();
  const { privacyPolicyUrl } = useSwireApp(whitelabel);
  const agreementLinks = useMemo(() => {
    const links: React.ReactElement[] = [];

    links.push(createLink());

    return links;
  }, [whitelabel]);

  function createLink( ) {
    const linkText = t('web.onboarding.userProfile.privacyPolicyLabel');
    const redirectUrl = privacyPolicyUrl || '';

    return (
      <Link
        key={privacyPolicyUrl}
        data-test="link-to-parent"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline', color: 'inherit' }}
        to={{ pathname: redirectUrl }}
      >
        {linkText}
      </Link>
    );
  }


  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <SwireCommonTnC control={control} whitelabel={whitelabel} />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <HookFormCheckBox
          control={control}
          name="swire.hkTnC"
          data-test="onboarding-swire-hong-kong-tnc-checkbox"
          text={
            <div>
              <Trans
                i18nKey="web.onboarding.userProfile.swire.privacyPolicyAgreement"
                components={[agreementLinks[0]]}
              />
              <span
                style={{ color: colors.neutral.red7200, marginLeft: '0px' }}
              >
                *
              </span>
            </div>
          }
          labelStyles={labelStyles}
          isRequired
        />
      </div>
      <div>
        <HookFormCheckBox
          control={control}
          name="marketingOptIn"
          data-test="onboarding-swire-other-tnc-5-checkbox"
          text={
            <Trans i18nKey="web.onboarding.userProfile.swire.marketingAgreement" />
          }
          labelStyles={labelStyles}
        />
      </div>
    </>
  );
}
